<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="userManagementTableRef">
      <wt-form-table-list ref="userManagementTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="tableTopCustom">
          <div class="table-list-desc">共有 {{form.formResult.total}} 用户</div>
        </template>
      </wt-form-table-list>
    </wt-form-table>
    <el-dialog title="资金记录" :visible.sync="openUserMoney" width="80%" append-to-body>
      <UserMoneyList :userid="dataForm.id" v-if="openUserMoney"></UserMoneyList>
    </el-dialog>
  </div>
</template>

<script>
import UserMoneyList from '@/modules/sk/user/userManagement/userMoneyList.vue'

export default {
  components: { UserMoneyList },
  data() {
    return {
      openUserMoney: false,
      dataForm: null,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_MANAGEMENT_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablUser/dataList' }
        },
        formInputsData: [
          { name: '手机号', key: 'phone', value: '', type: 'text' },
          { name: 'userid', key: 'userId', type: 'text' },
          { name: '状态',
            key: 'status',
            value: '',
            type: 'select',
            data: [
              { label: '全部', value: '' },
              { label: '启用', value: '1' },
              { label: '停用', value: '2' }
            ] }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablUser/exportExcel',
          fileName: '用户管理',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '所属公司名称', key: 'companyName' },
          { name: '用户id', key: 'userId', type: 'text' },
          { name: '用户电话', key: 'phone', type: 'text' },
          { name: '投递次数', key: 'totalDeliveryCount', type: 'text' },
          { name: '投递总金额(元)', key: 'totalDeliveryAmount', type: 'text' },
          { name: '投递总重量(千克)', key: 'totalDeliveryWeight', type: 'text' },
          { name: '余额', key: 'balance', type: 'text' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '创建时间', key: 'createdAt', type: 'text' },
          { name: '更新时间', key: 'updatedAt', type: 'text' }],
        formTableButtonsData: [{ name: '投递记录', key: 'DELIVERYRECORD', action: 'DELIVERYRECORD', className: 'primary', permission: 'DELIVERYRECORD' },
          { name: '资金记录', key: 'USERMONEY', action: 'USERMONEY', className: 'primary', permission: 'USERMONEY' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonMinWidth: 240, buttonWidth: 240 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      const that = this
      if (data && data.item) {
        if (data.item.action === 'DELIVERYRECORD') {
          that.$router.push({
            name: 'deliveryRecordList',
            query: { userid: data.row.userId }
          })
        } else if (data.item.action === 'USERMONEY') {
          that.dataForm = data.row
          that.openUserMoney = true
        }
      }
    }
  }
}
</script>
<style scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
